import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import VideoThumbsList from "./VideoThumbsList";
import { DashboardApi } from "../../../api/DashboardApi";

const REFRESH_INTERVAL_MS = 300 * 1000;

const VideoThumbsListPanel = () => {

    const [videoList, setVideoList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await DashboardApi.getDashboardVideoList();
            if (data) {
                setVideoList(data);
            }
        };
        fetchData();
        const interval = setInterval(fetchData, REFRESH_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    return (
        <Box sx={{ paddingLeft: 2, paddingTop: 2, backgroundColor: "rgb(0, 0, 0)" }}>
            <VideoThumbsList items={videoList} />
        </Box>
    );
};

export default VideoThumbsListPanel;
